/**
 * Bluekai audience integration
 * @module
 */

var VENDOR = 'bluekai';

var _ = require('optimizely-client-fn');
var PromiseEnv = require('core/lib/promise').Promise;

var Poll = require('core/utils/poll');
var WindowEnv = require('core/env/window');



/**
 * @returns {Object|undefined}
 */
function getBlueKaiData(): any|undefined {
  var blueKai = WindowEnv.getGlobal('bk_results');
  if (blueKai && blueKai.hasOwnProperty('campaigns')) {
    var campaigns = _.reduce(blueKai.campaigns, function (memo, campaign) {
      if (!!campaign.campaign) {
        memo.push(campaign.campaign);
      }
      return memo;
    }, []);

    return {
      campaigns: campaigns,
    };
  }
}

var pluginAudienceBluekai:AudiencePluginConfig = {
  provider: {
    isAsync: true,

    getter: [
      function() {
        return function(getValue, setValue) {
          var initialBlueKaiData = getBlueKaiData();
          if (initialBlueKaiData) {
            // Synchronously populate the visitor profile to avoid FOUC on pages with synchronous BlueKai snippets.
            setValue(initialBlueKaiData);
            return PromiseEnv.resolve(initialBlueKaiData);
          } else {
            // Asynchronously populate the visitor profile on pages with asynchronous BlueKai snippets.
            return Poll.pollFor(getBlueKaiData);
          }
        };
      }
    ],
  },

  matcher: require('core/plugins/matchers/key_value'),

  vendor: VENDOR,
};

module.exports = function(PluginManager) {
  PluginManager.registerAudiencePlugin(pluginAudienceBluekai);
};

if (__TEST__) {
  module.exports.plugin = pluginAudienceBluekai;
}
